const REF_KEY = "stunm_referral_ref";
const VISITOR_KEY = "stunm_referral_visitor_id";
const VISIT_KEY = "stunm_referral_visit_id";
const SESSION_KEY = "stunm_referral_session_id";
const POST_TOKEN_KEY = "stunm_post_tracking_token";
const POST_TOKEN_CAPTURED_KEY = "stunm_post_tracking_token_captured_at";
const POST_TOKEN_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const REF_PATTERN = /^[A-Za-z0-9._-]{1,100}$/;
const POST_TOKEN_PATTERN = /^[A-Za-z0-9_-]{1,100}$/;

export function normalizePostTrackingToken(value) {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return POST_TOKEN_PATTERN.test(normalized) ? normalized : null;
}

export function capturePostTrackingToken(search = window.location.search) {
  const queryToken = normalizePostTrackingToken(new URLSearchParams(search).get("st_post"));
  let cookieToken = null;
  try {
    const match = document.cookie.match(/(?:^|;\s*)st_post=([^;]+)/);
    if (match) cookieToken = normalizePostTrackingToken(decodeURIComponent(match[1]));
  } catch (error) {}
  const token = queryToken || cookieToken;
  if (token) {
    try {
      localStorage.setItem(POST_TOKEN_KEY, token);
      localStorage.setItem(POST_TOKEN_CAPTURED_KEY, String(Date.now()));
    } catch (error) {}
  }
  return token || getPostTrackingToken();
}

export function getPostTrackingToken() {
  try {
    const stored = normalizePostTrackingToken(localStorage.getItem(POST_TOKEN_KEY));
    const capturedAt = Number(localStorage.getItem(POST_TOKEN_CAPTURED_KEY) || 0);
    if (stored && capturedAt && Date.now() - capturedAt < POST_TOKEN_TTL_MS) return stored;
    localStorage.removeItem(POST_TOKEN_KEY);
    localStorage.removeItem(POST_TOKEN_CAPTURED_KEY);
    const cookieToken = captureCookiePostTrackingToken();
    if (cookieToken) {
      localStorage.setItem(POST_TOKEN_KEY, cookieToken);
      localStorage.setItem(POST_TOKEN_CAPTURED_KEY, String(Date.now()));
    }
    return cookieToken;
  } catch (error) {
    return captureCookiePostTrackingToken();
  }
}

function captureCookiePostTrackingToken() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)st_post=([^;]+)/);
    return match ? normalizePostTrackingToken(decodeURIComponent(match[1])) : null;
  } catch (error) { return null; }
}

export function normalizeReferral(value) {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return REF_PATTERN.test(normalized) ? normalized : null;
}

function getOrCreate(storage, key, createValue) {
  try {
    const current = storage.getItem(key);
    if (current) return current;
    const value = createValue();
    storage.setItem(key, value);
    return value;
  } catch (error) {
    return createValue();
  }
}

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function captureReferral(search = window.location.search) {
  capturePostTrackingToken(search);
  const value = normalizeReferral(new URLSearchParams(search).get("ref"));
  try {
    if (value && !localStorage.getItem(REF_KEY)) localStorage.setItem(REF_KEY, value);
  } catch (error) {
    // Storage may be disabled; the current page can still be tracked.
  }
  return getReferralAttribution();
}

export function getReferralAttribution() {
  let ref = null;
  try { ref = normalizeReferral(localStorage.getItem(REF_KEY)); } catch (error) {}
  return {
    ref,
    visitorId: getOrCreate(localStorage, VISITOR_KEY, randomId),
    sessionId: getOrCreate(sessionStorage, SESSION_KEY, randomId),
    visitId: (() => {
      try { return sessionStorage.getItem(VISIT_KEY); } catch (error) { return null; }
    })(),
  };
}

export function saveReferralVisitId(visitId) {
  try { sessionStorage.setItem(VISIT_KEY, visitId); } catch (error) {}
}
